module.exports = __webpack_public_path__ + "media/images/flag-ebd39e70e62504495840cded2bce5aaa.png";